import { Action } from '@ngrx/store';

export const BOOTSTRAP_COMPLETE = 'BOOTSTRAP_COMPLETE';

export class BootstrapCompleteAction implements Action {
  readonly type = BOOTSTRAP_COMPLETE;

  constructor() {}
}

export type BootstrapActions = BootstrapCompleteAction;
